import { render, staticRenderFns } from "./HistoryImportTPM.vue?vue&type=template&id=c4d2a5d8"
import script from "./HistoryImportTPM.vue?vue&type=script&lang=js"
export * from "./HistoryImportTPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports